export enum Gender {
  WOMAN = 'MME',
  MAN = 'MR',
}

export enum Nationality {
  FRENCH = 'french',
  OTHER = 'other',
}

export enum NationalityInput {
  NATIONALITY = 'nationality',
  BIRTH_COUNTRY = 'birthCountry',
}
